import { useActive } from "~map-view/states/sketch";
export function useSketchTitle() {
	const active = useActive();
	switch (active) {
		case "Sketch":
			return "Sketch";
		case "line":
			return "Add a line";
		case "polygon":
			return "Add a polygon";
		case "rectangle":
			return "Add a rectangle";
		case "circle":
			return "Add a circle";
		case "marker":
			return "Add a marker";
		case "text-annotation":
			return "Add a text annotation";
		case "Create Sketch":
			return "Create a sketch";
		default:
			return "Sketches";
	}
}
